<template>
    <div class="col mt-4">
        <div class="c-service c-service--active">
            <div
                class="c-service__basic"
                :class="{
                    row: service.graphics && service.graphics.smallIconMinioUrl
                }"
            >
                <div
                    class="col-4"
                    v-if="
                        service.graphics && service.graphics.smallIconMinioUrl
                    "
                >
                    <router-link
                        :to="goToServiceDetails()"
                    >
                        <img
                            :src="service.graphics.smallIconMinioUrl"
                            alt
                            class="img-fluid"
                        />
                    </router-link>
                </div>
                <div
                    class="col-8"
                    v-if="
                        service.graphics && service.graphics.smallIconMinioUrl
                    "
                >
                    <h2 class="c-service__title">
                        <router-link
                            :to="goToServiceDetails()"
                        >
                            {{ service.name }}
                        </router-link>
                    </h2>
                    <p class="c-service__status">
                        Usługa jest
                        <strong>{{ activeWord }}</strong>
                    </p>
                </div>
                <template v-else>
                    <h2 class="c-service__title">
                        <router-link
                            :to="goToServiceDetails()"
                        >
                            {{ service.name }}
                        </router-link>
                    </h2>
                    <p class="c-service__status">
                        Usługa jest
                        <strong>{{ activeWord }}</strong>
                    </p>
                </template>
            </div>

            <div class="c-service__desc" v-html="$options.filters.sanitizeHtml(service.description)" />

            <h3 class="c-service__sub">
                <router-link :to="goToServiceDetails()">
                    Dowiedz się więcej
                </router-link>
            </h3>

            <ul class="c-service__list">
                <li v-if="benefits">
                    <router-link
                        :to="goToServiceDetails('#benefity')"
                    >
                        Sprawdź benefity
                    </router-link>
                </li>
                <li>
                    <router-link
                        :to="goToServiceDetails('#dokumenty')"
                    >
                        Pokaż dokumenty
                    </router-link>
                </li>
                <li
                    v-if="
                        service.number_of_entities_with_subscription > 0 &&
                            isLocationLevelService
                    "
                >
                    <a>
                        Aktywowano w
                        <strong>
                            {{ service.number_of_entities_with_subscription }}
                        </strong>
                        {{
                            service.number_of_entities_with_subscription === 1
                                ? 'sklepie'
                                : 'sklepach'
                        }}
                    </a>
                </li>
            </ul>

            <div class="c-service__actions justify-content-end">
                <div
                    class="d-flex flex-wrap justify-content-center"
                    style="width: max-content"
                >
                    <button
                        v-if="
                            serviceCustomAction &&
                                service.number_of_entities_with_subscription > 0
                        "
                        type="button"
                        class="btn btn-secondary m-1 px-5"
                        @click="
                            isLotteryUser
                                ? $store.dispatch('onLotteryUserNoPermission')
                                : goToServiceClickHandler()
                        "
                        style="flex: 1"
                    >
                        Przejdź
                    </button>
                    <router-link
                        v-if="
                            service.number_of_entities_with_subscription > 0 &&
                                !isAvailableSection
                        "
                        class="btn btn-secondary m-1"
                        :to="goToServiceDetails()"
                        style="flex: 1"
                    >
                        Zarządzaj usługą
                    </router-link>

                    <template v-else>
                        <the-btn
                            type="button"
                            class="btn btn-secondary m-1"
                            text="Włącz usługę"
                            :disabled="!canActivateService"
                            v-tooltip="activateServiceTooltip"
                            @click="activateService"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TEST_SERVICE_CODE as DRS_TEST_CODE, SERVICE_CODE as DRS_CODE } from '@/store/modules/drs/drs.module'
export default {
    drsMultiNipDisabledTooltip: 'Twoje konto jest kontem multiNIPowym. Do momentu wprowadzenia obsługi takich kont w EuroPlatform <br>zachęcamy do aktywacji pakietu i korzystania z systemu kaucyjnego przez portal Kaucyjni.pl.<br/>Szczegółowe informacje oraz kod rabatowy otrzymasz kontaktując się z <strong>pomoc@kaucyjni.pl</strong>',
    drsSingleNipDisabledTooltip: 'Możliwość aktywacji usługi została tymczasowo zablokowana.<br/>Skontaktuj się z <strong>pomoc@kaucyjni.pl</strong> aby uruchomić pakiet Specjalny EC w sklepach, które masz zarejestrowane w Kaucyjni.pl.',

    props: {
        service: {
            type: Object,
            require: true
        },
        isAvailableSection: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        serviceCustomAction() {
            return this.servicesWithCustomAction[this.service.code]
        },
        servicesWithCustomAction() {
            return this.$store.getters.getServicesWithCustomAction
        },
        activeWord() {
            return this.service.number_of_entities_with_subscription > 0
                ? 'aktywna'
                : 'nieaktywna'
        },
        benefits() {
            return this.service.description_long.includes('id="benefity"')
        },
        isLocationLevelService() {
            return this.service.level === 'Location'
        },
        isDrsTest() {
            return this.service.code === DRS_TEST_CODE
        },
        isDrs() {
            return this.service.code === DRS_CODE
        },
        canActivateService() {
            return this.service.activation_type === 'A' &&
                !this.isDrsTest &&
                (!this.isDrs || this.$store.getters.isDrsServiceAvailable) // Is not DRS, unless DRS is available
        },
        activateServiceTooltip() {
            if (this.isDrs && !this.$store.getters.isDrsServiceAvailable) {
                if (this.$store.getters.isMultiNip) {
                    return this.$options.drsMultiNipDisabledTooltip
                }

                return this.$options.drsSingleNipDisabledTooltip
            }

            if (!this.canActivateService && !this.isDrsTest) {
                return 'Funkcjonalność będzie dostępna w kolejnych wersjach aplikacji'
            }

            return ''
        }
    },
    methods: {
        goToServiceClickHandler() {
            if (this.serviceCustomAction.link) {
                window.location.href = this.serviceCustomAction.link
            }
        },
        activateService() {
            if (!this.canActivateService) {
                return
            }

            this.$store.dispatch('openModal', {
                component: 'AcceptService',
                args: {
                    fetchService: true,
                    service: this.service,
                    allShops: !this.isLocationLevelService,
                    isCheckedAllInactive: this.isLocationLevelService
                }
            })
        },
        goToServiceDetails(hash) {
            return { name: 'service', params: { id: this.service.id }, hash }
        }
    }
}
</script>
